import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useSupplierReducer = () => useSelector((state: ApplicationState) => state.supplier);
